import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";
import CreateVisitModal from "src/components/Modals/CreateVisitModal";
import { useManageModal } from "src/hooks/useManageModal";

type ContextType = {
  openCreateVisitModal: (patientId: number) => void;
};

export const PatientIntakesModalContext = createContext<ContextType>({
  openCreateVisitModal: () => {},
});

interface Props {
  children: ReactNode;
}

const PatientIntakeModalProvider = ({ children }: Props) => {
  const [patientId, setPatientId] = useState<number | null>(null);
  const [open, { handleClose, handleOpen }] = useManageModal();

  const handleOpenCreateVisitModal = useCallback(
    (patientId: number) => {
      setPatientId(patientId);
      handleOpen();
    },
    [handleOpen],
  );

  const handleCloseCreateVisitModal = useCallback(() => {
    setPatientId(null);
    handleClose();
  }, [handleClose]);

  const value = useMemo(
    () => ({
      patientId,
      openCreateVisitModal: handleOpenCreateVisitModal,
    }),
    [handleOpenCreateVisitModal, patientId],
  );

  return (
    <PatientIntakesModalContext.Provider value={value}>
      {children}

      <CreateVisitModal
        open={open}
        patientId={patientId}
        onClose={handleCloseCreateVisitModal}
      />
    </PatientIntakesModalContext.Provider>
  );
};

export default PatientIntakeModalProvider;
